import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import style from '../cssmodules/navbar.module.scss';
import Logo from '../icons/logo-gradient2.svg';
import LogoWhite from '../icons/logo-offwhite.svg';
import Button from './Button';

function Navbar({ home }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  function handleScroll() {
    if (window.scrollY > 110) {
      setIsScrolled(true);
    } else if (isScrolled && window.scrollY < 110) {
      setIsScrolled(false);
    }
  }

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return function cleanup() {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  function toggleMenu() {
    setIsOpen(!isOpen);
  }

  const homeClass = home ? 'is-home' : '';
  const scrolledClass = isScrolled ? 'is-scrolled' : '';

  return (
    <>
      <Helmet>
        <body className={[homeClass, scrolledClass].join(' ')} />
      </Helmet>
      <header className={style.header}>
        <div className={style.navbar}>
          <div className={style.siteTitle}>
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <div
            className={style.wrapper}
            id="navbar-menu"
            aria-hidden={!isOpen}
            aria-labelledby="navbar-burger"
          >
            <nav className={style.navMain}>
              <Link to="/about" activeClassName="is-active">
                About Us
              </Link>
              <Link to="/services" activeClassName="is-active">
                Services
              </Link>
              <Link to="/technologies" activeClassName="is-active">
                Technologies
              </Link>
              <Link to="/investor" activeClassName="is-active">
                Investor
              </Link>
              <Link to="/insights" activeClassName="is-active" partiallyActive>
                Insights
              </Link>
            </nav>
            <div className={style.contactMobile}>
              <Button link="/contact">Contact</Button>
            </div>
            <div className={style.mobileLogo}>
              <LogoWhite />
            </div>
          </div>
          <button
            className={style.hamburger}
            type="button"
            onClick={toggleMenu}
            aria-expanded={isOpen}
          >
            <span className={style.hide}>Menu</span>
            <span
              className={style.hamburgerBurgerPatty}
              aria-expanded={isOpen}
            />
          </button>
          <div className={style.contactDesktop}>
            <Button link="/contact" modifyer="btnRainbow">
              Contact
            </Button>
          </div>
        </div>
      </header>
    </>
  );
}

Navbar.defaultProps = {
  home: false,
};

Navbar.propTypes = {
  home: PropTypes.bool,
};

export default Navbar;
